export default __webpack_public_path__ + "static/media/Barat.9b2b3648.svg";